import type { FaireProductEntity } from "../../entity_types/product";

export const p_w8mq4nhtaw: FaireProductEntity = {
  token: "p_w8mq4nhtaw",
  type: "product",
  name: "SAUCE",
  brandToken: "b_z588h499tw",
  brandName: "LOHSO",
  imageUrl:
    "https://cdn.faire.com/fastly/951cfdfecb3174b55cc36ac9f8478792637ff08f79cc376aee857dd962e6dea9.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7771532b740af5624d8062d5562a4a73fa6a536b8fc5c724681345fa94d36eb5.png",
    "https://cdn.faire.com/fastly/92ff086de9217eeb0ab75c8c1c69ae0cc168eebd0a4df940ad9f6e98398698ca.jpeg",
    "https://cdn.faire.com/fastly/a95ac884c7b2045606584af3d0b877b9094b7c6366a873183cbb6c0b5ad80112.jpeg",
    "https://cdn.faire.com/fastly/bf85159538982494bed6089a33c08ae09c0b84aebc2a90e8d9420d24f015dd97.jpeg",
    "https://cdn.faire.com/fastly/e4a6b56db157142339568ce3f5ca6dc19ddc54b73a605f1760ba4bda4a53fa47.jpeg",
  ],
  priceDollars: 10,
  description:
    "LOHSO SAUCE is your new (not) soy sauce - Gluten free and 53% less sodium than the leading soy sauce.\n\nSAUCE is intentionally crafted with just two organic ingredients to keep it simple. Our fermentation process creates a rich, umami taste, while still making you feel good. \n\nIngredients: \n- Organic Coconut Tree Sap (it doesn't taste like coconut!) \n- Sea Salt \n\nLOHSO is a coconut aminos based sauce.",
  tags: [],
  msrpDollars: 16.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:10.858Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
